/**
 * 认证相关工具函数
 */

// 设置Cookie
export function setCookie(name, value, time) {
  if (time) {
    const hours = time.expires // 单位小时
    const exp = new Date()
    exp.setTime(exp.getTime() + hours * 60 * 60 * 1000)
    document.cookie = name + "=" + escape(value) + ";expires=" + exp.toGMTString() + ";path=/"
  } else {
    document.cookie = name + "=" + escape(value) + ";path=/"
  }
}

// 获取Cookie
export function getCookie(name) {
  const reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)") // 正则匹配
  const arr = document.cookie.match(reg)
  if (arr) {
    return unescape(arr[2])
  } else {
    return null
  }
}

// 删除Cookie
export function removeCookie(name) {
  setCookie(name, '', { expires: -1 })
}

// 获取Token
export function getToken() {
  return getCookie('jubao_user') || getCookie('token')
}

// 移除Token
export function removeToken() {
  removeCookie('jubao_user')
  removeCookie('token')
}

// 检查是否已登录
export function isLoggedIn() {
  return !!getToken()
}

// 获取用户角色
export function getUserRole() {
  return getCookie('role') || 'admin'
}

// 获取用户信息
export function getUserInfo() {
  const userInfo = getCookie('userInfo')
  if (userInfo) {
    try {
      return JSON.parse(userInfo)
    } catch (e) {
      return null
    }
  }
  return null
}

// 设置用户信息
export function setUserInfo(userInfo) {
  setCookie('userInfo', JSON.stringify(userInfo))
}